function About() {
  return (
    <>
      <h1 className='text-6xl mb-4'>GitHub Finder</h1>
      <p className='mb-4 text-2xl font-light'>
        A React app to search GitHub profiles and see profile details. This
        project was designed as part in a React development course.
      </p>
      <p className='text-lg text-gray-400'>
        Version: <span className='text-white'>1.0.0</span>
      </p>
      <p className='text-lg text-gray-400'>
        Built by:
        <a className='text-white ml-2' href='https://twitter.com/kvnwdev'>
          Kevin Willoughby
        </a>
      </p>
    </>
  );
}
export default About;
